module.exports = __webpack_public_path__ + "img/gonglv.e01fdca9.svg";